import { BASE_URL } from "../../Environment/config";
import { httpClient } from "../../Http/client";

export const confirmEmail = async (token) => {
  const url = `${BASE_URL}/confirm-email/${token}`;
  const { data } = await httpClient.get(url);
  return data;
};
